import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { IdentificacionComercioResponse } from 'src/app/global/interfaces/identificacion-comercio-response';
import { environment } from '../../../../../environments/environment';
import { DatosComercio, LlamarCliente } from '../../../interfaces/datos-comercio';
import { DatosComercioService } from '../../../services/datos-comercio.service';


@Injectable()
export class DatosComercioProvider extends DatosComercioService {

  private api = environment.api;
  private endpoints = this.api.endpoints.PASO_2;
  private endpointsPTres = this.api.endpoints.PASO_3;

  constructor(private http: HttpClient) {
    super();
  }

  obtieneIdentificacionComercio(correo: string): Observable<IdentificacionComercioResponse> {
    const endopoint = this.api.host + this.api.path + this.endpoints.IDENTIFICACION_COMERCIO;
    if (correo !== undefined && correo !== null && correo !== '') {
      let params = new HttpParams();
      params = params.append('correo', correo);
      return this.http.get<IdentificacionComercioResponse>(endopoint, {params});
    } else {
      return this.http.get<IdentificacionComercioResponse>(endopoint);
    }
  }

  registraDatosComercio(datosComercio: DatosComercio): Observable<any> {
    const endopoint = this.api.host + this.api.path + this.endpoints.DATOS_COMERCIO;

    return this.http.post(endopoint, datosComercio);
  }

  obtieneLocalizaciones(): Observable<any> {
    const endopoint = this.api.host + this.api.path + this.endpoints.LOCALIZACIONES;
    return this.http.get(endopoint);
  }

  autenticaComercio(run: number, tokenExterno: String): Observable<any> {
    const endopoint: string = this.api.host + this.api.path + this.endpointsPTres.AUTENTICA_COMERCIO;
    const body = {
      run,
      tokenExterno
    };
    return this.http.post(endopoint, body);
  }

  obtenerCartaPoder(): Observable<any> {
    const endopoint: string = this.api.host + this.api.path + this.endpointsPTres.CARTA_PODER;
    return this.http.get(endopoint);
  }
  
  llamarCliente(llamarCliente: LlamarCliente): Observable<any> {
    const endopoint: string = this.api.host + this.api.path + this.endpointsPTres.LLAMAR_CLIENTE;
    return this.http.post(endopoint, llamarCliente);
  }

}
